import React, { useCallback, useMemo, useState } from "react";
import { Box } from "@mui/system";
import { Controller } from "react-hook-form";
import {
  SubmitButton,
  ErrorField,
  RadioButtonGroup,
} from "../../components/form";
import {
  FormControlLabel,
  Switch,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  Grid,
  useTheme,
} from "@mui/material";
import { Fragment } from "react";
import AnimateButton from "components/extended/AnimateButton";
import OutlinedInputComponent from "components/form/outlined-input/OutlinedInput.component";
import { useTranslation } from "react-i18next";

const StationDetailForm = ({
  errors,
  control,
  isSubmitting = false,
  handleSubmit = () => { },
  labelButton,
  title = "",
  handleCloseDialog = () => { },
  station,
  isAdd = true
}) => {
  const { t } = useTranslation()
  const theme = useTheme();
  const [hasAmbientSensor, setHasAmbientSensor] = useState(
    station?.envMonitoring
  );
  const [hasCamera, setHasCamera] = useState(station?.camera);
  const [haswifi, setHasWifi] = useState(station?.wifi);
  const [hasGateway, setHasGateway] = useState(station?.gateway);

  const onChangeGateway = useCallback((e, onChange) => {
    onChange(e);
    setHasGateway(e.target.value === "false" || e.target.value === false);
  }, []);

  const onChangeEnv = useCallback((e, onChange) => {
    onChange(e);
    setHasAmbientSensor(e.target.value === "false" || e.target.value === false);
  }, []);

  const onChangeCamera = useCallback((e, onChange) => {
    onChange(e);
    setHasCamera(e.target.value === "false" || e.target.value === false);
  }, []);

  const onChangeWifi = useCallback((e, onChange) => {
    onChange(e);
    setHasWifi(e.target.value === "false" || e.target.value === false);
  }, []);

  const envMonitoringType = useMemo(
    () => [
      { label: t('base'), value: "base" },
      { label: t('advanced'), value: "advanced" },
    ],
    [t]
  );

  const connectivityType = useMemo(
    () => [
      { label: "4g", value: "4g" },
      { label: t('Optic fiber'), value: "optical_fiber" },
    ],
    [t]
  );



  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit}
      sx={{ height: "100%", width: "100%" }}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        {!!isAdd && <Controller
          name="id"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              label='ID'
              error={errors?.id}
              {...field}
            />
          )}
        />}

        <Controller
          name="tag"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.tag}
              label="Tag"
              {...field}
            />
          )}
        />

        <Controller
          name="alias"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.alias}
              label="Alias"
              {...field}
            />
          )}
        />

        <Controller
          name="cluster"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.cluster}
              required={true}
              label="Cluster*"
              {...field}
            />
          )}
        />

        <Controller
          name="address"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.address}
              required={true}
              label={`${t('Address')}*`}
              {...field}
            />
          )}
        />

        <Controller
          name="lat"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.lat}
              required={true}
              label={`${t('Latitude')}*`}
              type="number"
              {...field}
            />
          )}
        />

        <Controller
          name="long"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.long}
              required={true}
              label={`${t('Longitude')}*`}
              type="number"
              {...field}
            />
          )}
        />

        <Controller
          name="description"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <OutlinedInputComponent
              error={errors?.description}
              label={t('Description')}
              {...field}
            />
          )}
        />

        <Controller
          name="connectivityType"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <RadioButtonGroup
              label={t('Connectivity type')}
              name="connectivityType"
              defaultValue={""}
              options={connectivityType}
              {...field}
            />
          )}
        />
        {errors?.connectivityType ? (
          <ErrorField message={t(errors?.connectivityType?.message)} />
        ) : null}

        <Grid container alignItems={"top"} sx={{ display: "flex" }}>
          <Grid item xs={6}>
            <Controller
              name="envMonitoring"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <FormControlLabel
                  checked={field.value ? field.value : false}
                  control={<Switch />}
                  label={t('Environment monitoring')}
                  {...field}
                  onChange={(e) => onChangeEnv(e, field.onChange)}
                />
              )}
            />
            {errors?.envMonitoring ? (
              <ErrorField message={t(errors?.envMonitoring?.message)} />
            ) : null}
          </Grid>

          <Grid item xs={6}>
            {!!hasAmbientSensor && (
              <Fragment>
                <Controller
                  name="envMonitoringType"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Box>
                      <RadioButtonGroup
                        label={t('Type of environmental monitoring')}
                        name="envMonitoringType"
                        //defaultValue={envMonitoringType[0].value}
                        options={envMonitoringType}
                        {...field}
                        value={field?.value !== undefined ? field?.value : envMonitoringType[0].value}

                      />
                    </Box>
                  )}
                />
                {errors?.envMonitoringType ? (
                  <ErrorField message={t(errors?.envMonitoringType?.message)} />
                ) : null}
              </Fragment>
            )}
          </Grid>
        </Grid>

        <Grid container alignItems={"top"} sx={{ display: "flex" }}>
          <Grid item xs={4}>
            <Controller
              name="camera"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <FormControlLabel
                  checked={field.value ? field.value : false}
                  control={<Switch />}
                  label="Camera"
                  {...field}
                  onChange={(e) => onChangeCamera(e, field.onChange)}
                />
              )}
            />
            {errors?.camera ? (
              <ErrorField message={t(errors?.camera?.message)} />
            ) : null}
          </Grid>
          <Grid item xs={8}>
            {hasCamera && (
              <Controller
                name="cameraAddress"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <OutlinedInputComponent
                    error={errors?.cameraAddress}
                    label={t('Camera address')}
                    {...field}
                  />
                )}
              />
            )}
          </Grid>
        </Grid>

        <Grid container alignItems={"top"} sx={{ display: "flex" }}>
          <Grid item xs={4}>
            <Controller
              name="wifi"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <FormControlLabel
                  checked={field.value ? field.value : false}
                  control={<Switch />}
                  label="WiFi"
                  {...field}
                  onChange={(e) => onChangeWifi(e, field.onChange)}
                />
              )}
            />
            {errors?.wifi ? (
              <ErrorField message={t(errors?.wifi?.message)} />
            ) : null}
          </Grid>
          <Grid item xs={8}>
            {!!haswifi && (
              <Controller
                name="wifiAddress"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <OutlinedInputComponent
                    error={errors?.wifiAddress}
                    label={t('WiFi address')}
                    {...field}
                  />
                )}
              />
            )}
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12}>
            <Controller
              name="peopleCounter"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <FormControlLabel
                  checked={field.value ? field.value : false}
                  control={<Switch />}
                  label={t('People counter sensor')}
                  {...field}
                />
              )}
            />
            {errors?.peopleCounter ? (
              <ErrorField message={t(errors?.peopleCounter?.message)} />
            ) : null}
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="gateway"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <FormControlLabel
                  checked={field.value ? field.value : false}
                  control={<Switch />}
                  label="Gateway"
                  {...field}
                  onChange={(e) => onChangeGateway(e, field.onChange)}
                />
              )}
            />
            {errors?.gateway ? (
              <ErrorField message={t(errors?.gateway?.message)} />
            ) : null}
          </Grid>
        </Grid>

        {!!hasGateway && (
          <Fragment>
            <Controller
              name="gatewayID"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <OutlinedInputComponent
                  label={t('Gateway ID')}
                  error={errors?.gatewayID}
                  {...field}
                />
              )}
            />

            <Controller
              name="gatewayMAC"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <OutlinedInputComponent
                  label={t('Gateway MAC')}
                  error={errors?.gatewayMAC}
                  {...field}
                />
              )}
            />

            <Controller
              name="gatewaySerial"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <OutlinedInputComponent
                  label={t('Serial Gateway')}
                  error={errors?.gatewaySerial}
                  {...field}
                />
              )}
            />

            <Controller
              name="gatewayAddress"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <OutlinedInputComponent
                  label={t('Gateway address')}
                  error={errors?.gatewayAddress}
                  {...field}
                />
              )}
            />

            <Controller
              name="gatewayAddressInternal"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <OutlinedInputComponent
                  label={t('Gateway internal address')}
                  error={errors?.gatewayAddressInternal}
                  {...field}
                />
              )}
            />
          </Fragment>
        )}


      </DialogContent>

      <Box m={8} />
      <DialogActions
        sx={{
          zIndex: 999,
          position: "fixed",
          width: "100%",
          maxWidth: 500,
          bottom: 0,
          right: 0,
          backgroundColor:
            theme.palette.mode === "dark" ? theme.palette.dark.dark : "white",
        }}
      >
        <AnimateButton>
          <SubmitButton label={labelButton} isSubmitting={isSubmitting} />
        </AnimateButton>
        <Button variant="text" color="error" onClick={handleCloseDialog}>
          {t('Close')}
        </Button>
      </DialogActions>
    </Box>
  );
};

export default StationDetailForm;
